import React, { useContext, useState} from 'react';
import { Table, EllipsisDropdown, Person, ControlledPopup, yup, generateResolver, STATUS_TYPES, Notification } from 'dyl-components';
import { Checkbox, DropdownItem, Header, Icon, Popup } from 'semantic-ui-react';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import { PhoneUtil } from 'utils';
import ViewLoginInfoPopup from '../../Extensions/Users/subcomponents/ViewLoginInfoPopup';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import provisionActions from 'actions/provision';

const Row = ({ device = {}, onEditDevice, onDeleteDevice }) => {
    const { id, type, model, ip_addr, user, extension, label, mac_addr, active, location } = device;
    const [selectedDevices, setSelectedDevices] = useContext(BulkActionsContext);
    const [isLoginInfoOpen, setIsLoginInfoOpen] = useState(false);    

    const dispatch = useDispatch();

    const isSelected = (device_id) => {
        return selectedDevices.includes(device_id);
    }

    const onToggleDevice = (device_id) => {
        const newSelectedDevices = isSelected(device_id) ? selectedDevices.filter(id => device_id !== id) : [...selectedDevices, device_id];
        setSelectedDevices(newSelectedDevices);
    }

    const { control, handleSubmit, formState: { isDirty, isValid }, reset } = useForm({
        mode: 'onChange',
        defaultValues: {
            password: ''
        },
        resolver: generateResolver({
            password: yup.string().required("This field is required")
        })
    });

    const onCloseViewLoginInfo = () => {
        dispatch(provisionActions.removeSoftphoneCreds());
        reset({password: ''});
        setIsLoginInfoOpen(false);
    };

    const onNext = async (data) => {
        try {
            const { password } = data;
            await dispatch(provisionActions.getSoftphoneCreds(extension, { password }));
        } catch (error) {
            console.log(error)
            Notification.alert('Invalid credentials!', STATUS_TYPES.ERROR);
        }
    }

    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox checked={isSelected(id)} onChange={() => { onToggleDevice(id) }} />
            </Table.Cell>
            <Table.Cell>
                {PhoneUtil.DEVICE_TYPES_OPTIONS.find((option) => option.key === type)?.text}
            </Table.Cell>
            <Table.Cell>
                {model?.includes("Browser Softphone") ? <><div>Browser</div><div>Sofphone</div></> : model}
            </Table.Cell>
            <Table.Cell>
                <div>
                    {mac_addr}
                </div>
                <div>
                    {ip_addr}
                </div>
            </Table.Cell>
            <Table.Cell>
                {user && (
                    <Person username={`${user.first_name} ${user.last_name}`} email={user.email} isInactiveUser={!user.active} />
                )}
            </Table.Cell>
            <Table.Cell>
                {extension}
            </Table.Cell>
            <Table.Cell>
                {label}
            </Table.Cell>
            <Table.Cell>
                <>
                    <Icon name='circle' className={`Devices__statusIcon${active ? "--green" : "--red"}`} />
                    {active ? "Online" : "Offline"}
                </>
            </Table.Cell>
            <Table.Cell>
                {location && (
                    <div>
                        <strong>{location.label}</strong>
                        <p>{location.address}<br />{`${location.city} ${location.state}, ${location.zip}`}</p>
                    </div>
                )}
            </Table.Cell>
            <Table.Cell>
                <Popup
                    style={{minWidth:250}}
                    trigger={
                        <EllipsisDropdown {...isLoginInfoOpen ? { isDropdownOpen: false } : {}}>
                            {type === "softphone" && (
                                <DropdownItem 
                                    text={"View credentials"}
                                    icon={'fa-solid fa-eye'}
                                    onClick={() => setIsLoginInfoOpen(true)}
                                />
                            )}
                            <DropdownItem
                                text={"Edit"}
                                icon={"fa-solid fa-pencil"}
                                onClick={() => onEditDevice(id, type)}
                            />
                            {type !== "browser" && (
                                <ControlledPopup
                                    header={
                                        <Header as='h4' textAlign='center'>
                                            Are you sure?
                                            <Header.Subheader style={{ marginTop: 5 }}>
                                                The {type} will be disconnected.
                                            </Header.Subheader>
                                        </Header>
                                    }
                                    trigger={<DropdownItem
                                        text='Delete'
                                        icon='fa-solid fa-trash'
                                    />}
                                    onConfirm={() => onDeleteDevice(id, type)}
                                    inverted
                                />
                            )}
                        </EllipsisDropdown>
                    }
                    on="click"
                    content={
                        <ViewLoginInfoPopup
                            control={control}
                            onNext={handleSubmit(onNext)}
                            isDisabled={!isDirty || !isValid}
                            extension={extension}
                            onClose={onCloseViewLoginInfo}
                        />
                    }
                    position="bottom center"
                    open={isLoginInfoOpen}
                    onOpen={() => setIsLoginInfoOpen(true)}
                    onClose={onCloseViewLoginInfo}
                    size='small'
                />
            </Table.Cell>
        </Table.Row>
    );
}

export default Row;


